<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">Hawa Crickmore was born in Ghana in 1958. She has a Bachelor of Education in Management and has taught at various levels of education. She has also studied at Middlesex University in London and obtained a master’s degree in health and social care, which motivated her to establish a care service and training company with her husband, Ken.</p>
<br/><p style="text-indent:00em;">She enjoys the art of writing and has successfully published her first novel, <em>Across the Ocean. The Neighbour at Number 18</em> is her second novel.</p>
<br/><p style="text-indent:00em;">Hawa has two sons, two daughters, two stepdaughters and three grandchildren. She currently resides with her husband in Kent in the United Kingdom.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?264df970